import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import Modal from '@bd/bdui-modal';
import withData from '@bd/bdcore-data';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import { css, cx } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';

const styles = css`
  .TeamDetails_wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;

class TeamModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal(e) {
    if (e) {
      e.preventDefault();
    }
    this.setState({ modalIsOpen: true });
  }

  closeModal(e) {
    if (e) {
      e.preventDefault();
    }
    this.setState({ modalIsOpen: false });
  }


  render() {
    const { children, team, plans } = this.props;
    const favorite = plans.find(item => item._id === team.favorite_plan);

    return (
      <div>
        <a href="" onClick={this.openModal}>
          {children}
        </a>
        <Modal
          className="modal-wrapper"
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          contentLabel="Example Modal"
          overlayClassName="modal-overlay"
        >
          <a href className="modal-close" onClick={this.closeModal}>&times;</a>
          <div className={cx('team-modal-header', styles)}>
            <div className="container">
              <div className="row">
                <div className="col-md-4">
                  <img src={team.photo.contentUrl} alt={team.name} />
                </div>
                <div className="col-md-8 TeamDetails_wrapper">
                  <h2>{get(team, 'name')}</h2>
                  <h3>{get(team, 'title')}</h3>
                  {
                    get(favorite, 'name') &&
                    <p className="text-white">
                      Favorite Plan: <Link name="plan-detail" plan={favorite}>{get(favorite, 'name')}</Link>
                    </p>
                  }
                  {
                    get(team, 'phone_number') &&
                    <span>Phone: <b>{get(team, 'phone_number')}</b></span>
                  }
                  {
                    get(team, 'email_address') &&
                    <a href={`mailto:${get(team, 'email_address')}`}>{team.email_text ? team.email_text : 'Email Me'}</a>
                  }
                </div>
              </div>
            </div>
          </div>
          {
            get(team, 'description') &&
            <div className="contact-modal-body">
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <p dangerouslySetInnerHTML={SanitizeHtml(get(team, 'description'))} />
                  </div>
                </div>
              </div>
            </div>
          }
        </Modal>
      </div>
    );
  }
}

TeamModal.propTypes = {
  team: PropTypes.object,
  children: PropTypes.node,
  plans: PropTypes.arrayOf(PropTypes.object.isRequired),
};

TeamModal.defaultProps = {
  team: undefined,
  children: undefined,
  plans: {},
};

export default withData({
  team: true,
  children: true,
  plans: true,
}, {
  required: {
    plans: true,
  },
})(TeamModal);



// WEBPACK FOOTER //
// ./src/pages/Team/teamModal.js